"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.taskOutputGranularities = exports.microtaskAssignmentBatchStatuses = exports.microtaskAssignmentStatuses = exports.taskAssignmentStatuses = exports.taskOpStatuses = exports.taskOpTypes = exports.microtaskStatuses = exports.taskStatuses = void 0;
exports.taskStatuses = ['DRAFT', 'PREVIEW', 'LIVE', 'COMPLETED'];
exports.microtaskStatuses = ['INCOMPLETE', 'COMPLETED', 'MANUALLY_EXPIRED'];
exports.taskOpTypes = [
    'PROCESS_INPUT',
    'GENERATE_OUTPUT',
    'EXECUTE_FORWARD_TASK_LINK',
    'EXECUTE_BACKWARD_TASK_LINK',
    'HANDLE_ASSIGNMENT_COMPLETION',
    'HANDLE_VERIFIED_ASSIGNMENTS',
    'HANDLE_MICROTASK_COMPLETION',
    'EXECUTE_AUTO_TRANSFORM',
    'LINK_BY_PHONE',
    'LINK_BY_WORKER_ID',
    'WORKER_DATAPOINT_EXPORT',
];
exports.taskOpStatuses = ['CREATED', 'RUNNING', 'COMPLETED', 'FAILED'];
exports.taskAssignmentStatuses = ['ASSIGNED', 'COMPLETED'];
exports.microtaskAssignmentStatuses = [
    'ASSIGNED',
    'COMPLETED',
    'SUBMITTED',
    'SKIPPED',
    'EXPIRED',
    'VERIFIED',
    'IGNORED',
    'MANUALLY_EXPIRED',
];
exports.microtaskAssignmentBatchStatuses = ['UNALLOCATED', 'ALLOCATED', 'INVALIDATED'];
exports.taskOutputGranularities = ['MICROTASK', 'ASSIGNMENT'];
//# sourceMappingURL=Tasks.js.map